export enum StatusProdutoBeneficiario {
  AguardandoComunicacaoComProvedor,
  AguardandoAtivacaoNoProvedor,
  Ativo,
  AguardandoBloqueio,
  Bloqueado,
  Recusado,
}
